const getters = {
  locationStr: state => {
    return `${state.user.location.latitude},${state.user.location.longitude}`
  },
}
export default getters